import BaseSelect from "../../../../components/Input/Select";

const Select = ({id, formik, settings = {}}) => {

    return (
        <BaseSelect
            name={id}
            layout="vertical"
            label={settings.title}
            options={settings.options}
            required={settings.required}
            description={settings.description}
            formik={formik}
        />
    )
};

export default Select;